import axios from "axios";
import axiosWithAuth from "./axiosInterceptor";
import axiosNoAuth from "./axiosNoAuth";
import {
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  GET_CITY,
  GET_MASTER,
  GET_PROFILE,
  GET_STATE,
  HELP_SEND_EMAIL,
  LOGIN,
  RESEND_OTP,
  VERIFY_OTP,
  UPLOAD_FILE,
  GET_NOTIFICATION,
  REMOVE_NOTIFICATION,
  CHANGE_PASSWORD_INSIDE,
  UPDATE_READ_NOTIFICATION,
  ADD_PRE_EMPLOYEE,
  GET_PRE_EMPLOYEE,
  GET_ASSESSMENT_HRA,
  GET_DOC_CONSULTANCY,
  GET_HEALTH_RISK,
  MANAGE_EMPLOYEE,
  ADD_EMPLOYEE,
  ENABLE_DISABLE_EMPLOYEE,
  UPDATE_PROFILE,
  EMPLOYEE_ENGAGEMENT,
  SEND_REMINDER,
  OHC_BASE_URL,
  SSO_LOGIN_OHC,
  USER_MODULE,
} from "./routes";

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  [key: string]: any;
}
const handleApiError = (error: any) => {
  if (error.response) {
    throw {
      status: error.response.status,
      message: error.response.data.message || "An error occurred",
      data: error.response.data,
    };
  } else if (error.request) {
    throw {
      message:
        "No response received from server. Please check your network connection.",
    };
  } else {
    throw {
      message: error.message,
    };
  }
};
export const loginApi = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosNoAuth.post(LOGIN, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const forgotPasswordApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosNoAuth.post(FORGOT_PASSWORD, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const verifyOtpApi = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosNoAuth.post(VERIFY_OTP, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const changePasswordApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosNoAuth.post(CHANGE_PASSWORD, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const changePasswordInsideApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(CHANGE_PASSWORD_INSIDE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const resendOtpApi = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosNoAuth.post(RESEND_OTP, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const helpSendEmailApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(HELP_SEND_EMAIL, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getProfileApi = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(GET_PROFILE);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const updateProfileApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(UPDATE_PROFILE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const GetMasterApi = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(`${GET_MASTER}/${data?.path}`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const GetStateApi = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(GET_STATE);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const GetCityApi = async (data: {
  state_id: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(GET_CITY, {
      params: data,
    });
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const uploadFileApi = async (data: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(UPLOAD_FILE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getNotificationApi = async (data: {
  role: string;
  referenceId: number;
  filter: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(GET_NOTIFICATION, {
      params: data,
    });
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const removeNotificationApi = async (data: {
  notificationId: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(REMOVE_NOTIFICATION, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const updateReadNotificationApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(UPDATE_READ_NOTIFICATION, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const addPreEmployeeApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(ADD_PRE_EMPLOYEE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getPreEmployeeApi = async (data: {
  companyId: number;
  search?: string;
  status?: string | number;
  from_date?: string;
  to_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        search: data.search ? data.search : undefined,
        companyId: data.companyId,
        status:
          data.status !== "0" && data.status !== undefined
            ? data.status
            : undefined,
        from_date: data.from_date ? data.from_date : undefined,
        to_date: data.to_date ? data.to_date : undefined,
      },
    };
    const response = await axiosWithAuth.get(GET_PRE_EMPLOYEE, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getAssessmentHraApi = async (data: {
  companyId: number;
  search?: string;
  year: number;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        search: data.search ? data.search : undefined,
        companyId: data.companyId,
        year: data.year,
      },
    };
    const response = await axiosWithAuth.get(GET_ASSESSMENT_HRA, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getDocConsultacyApi = async (data: {
  companyId: number;
  from_date?: string;
  to_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        companyId: data.companyId,
        from_date: data.from_date ? data.from_date : undefined,
        to_date: data.to_date ? data.to_date : undefined,
      },
    };
    const response = await axiosWithAuth.get(GET_DOC_CONSULTANCY, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getHealthRiskApi = async (data: {
  companyId: number;
  from_date?: string;
  to_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        companyId: data.companyId,
        from_date: data.from_date ? data.from_date : undefined,
        to_date: data.to_date ? data.to_date : undefined,
      },
    };
    const response = await axiosWithAuth.get(GET_HEALTH_RISK, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const getManageEmployeeApi = async (data: {
  companyId: number;
  search?: string;
  status: number;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        companyId: data.companyId,
        status: data?.status,
        search: data?.search ? data?.search : undefined,
      },
    };
    const response = await axiosWithAuth.get(MANAGE_EMPLOYEE, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const addManageEmployeeApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(ADD_EMPLOYEE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const enableDisableEmployeeApi = async (
  data: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(ENABLE_DISABLE_EMPLOYEE, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const employeeEngagementApi = async (data: {
  companyId: number;
  from_date?: string;
  to_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const config = {
      params: {
        companyId: data.companyId,
        from_date: data.from_date ? data.from_date : undefined,
        to_date: data.to_date ? data.to_date : undefined,
      },
    };
    const response = await axiosWithAuth.get(EMPLOYEE_ENGAGEMENT, config);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const sendReminderApi = async (
  email: string
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(
      SEND_REMINDER,
      {},
      {
        params: { email },
      }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
export const userModuleApi = async (id: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.get(USER_MODULE, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const SsoOHCLoginApi = async (
  email: string
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosWithAuth.post(
      SSO_LOGIN_OHC,
      { email },
      {
        baseURL: OHC_BASE_URL,
      }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
